import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import type { PayReportDrawerResponse } from '../types/payReportDrawer'

export const PAY_REPORT_DRAWER_QUERY_KEY = 'payment-reports-drawer'

export type PayReportDrawerParams = {
  teamMemberId: string
  startTime: string
  endTime: string
  page: number
  limit: number
  serviceUserIds?: string[]
}

function buildDrawerUrl(params: PayReportDrawerParams): string {
  const search = new URLSearchParams()
  search.set('startTime', params.startTime)
  search.set('endTime', params.endTime)
  search.set('pagination[page]', String(Math.max(1, params.page)))
  search.set('pagination[limit]', String(params.limit))
  params.serviceUserIds?.forEach((id, i) => {
    search.set(`serviceUserIds[${i}]`, id)
  })
  return `payment-reports/drawer/${params.teamMemberId}?${search.toString()}`
}

export function usePayReportDrawer(
  params: PayReportDrawerParams | null,
  enabled: boolean
) {
  return useQuery<PayReportDrawerResponse>(
    [PAY_REPORT_DRAWER_QUERY_KEY, params],
    () => {
      if (!params) {
        throw new Error('usePayReportDrawer: params required')
      }
      return getJSON({
        url: buildDrawerUrl(params),
        isRota: true
      })
    },
    {
      enabled: Boolean(enabled && params),
      staleTime: 30 * 1000,
      keepPreviousData: true
    }
  )
}
